import {INeighbourhood} from "../../api/Model";
import {useSlackSettingsStore} from "../../api/SlackSettingsStore";
import {useRemoteValue} from "../../util/RemoteValue";
import {useMemo} from "react";


export function useNeighbourhoodSlackUrl(neighbourhood: INeighbourhood) {
    const slackOrganizationRV = useSlackSettingsStore(state => state.organization);
    const slackOrganization = useRemoteValue(slackOrganizationRV, null);

    return useMemo(() => {
        return neighbourhood.slackChannelId && slackOrganization
            ? `${slackOrganization.url}archives/${neighbourhood.slackChannelId}`
            : undefined;
    }, [neighbourhood, slackOrganization]);
}
